module.exports = __webpack_public_path__ + "img/transportation-en.1087b57c.svg";